module.exports = __webpack_public_path__ + "static/img/american_express.2907770.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/payment_types/american_express.svg
// module id = m7Jy
// module chunks = 38